import axios from 'axios';

const API_BASE = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: `${API_BASE}/api`,
  headers: { 'Content-Type': 'application/json' },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('hai_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      const refresh = localStorage.getItem('hai_refresh_token');
      if (refresh && !error.config._retry) {
        error.config._retry = true;
        try {
          const res = await axios.post(`${API_BASE}/api/auth/refresh`, { refresh_token: refresh });
          localStorage.setItem('hai_token', res.data.token);
          error.config.headers.Authorization = `Bearer ${res.data.token}`;
          return api(error.config);
        } catch {
          localStorage.removeItem('hai_token');
          localStorage.removeItem('hai_refresh_token');
          window.location.href = '/login';
        }
      } else {
        localStorage.removeItem('hai_token');
        localStorage.removeItem('hai_refresh_token');
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
